import { render, staticRenderFns } from "./pi-order-tab.vue?vue&type=template&id=f8041df4&"
import script from "./pi-order-tab.vue?vue&type=script&lang=js&"
export * from "./pi-order-tab.vue?vue&type=script&lang=js&"
import style0 from "./pi-order-tab.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports